import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLoading from '../../../common/componentsV2/elements/PageLoading';
import {
  RcQuotesStyles,
} from './BackOfficeVehicleQuotes.styles';
import {
  addBackOfficeQuoteToCart,
  loadBackOfficeQuotes,
  removeBackOfficeQuoteFromCart,
  resetBackOfficeQuotes,
} from '../../../features/backofficeResults/backofficeResultsActions';
import { Layout } from '../components/Layout/Layout';
import { confirmAlert } from '../../../common/utils/alerts';
import {
  RiskContainer,
} from '../../../common/components/redesignComponents/Cards/ProfessionInfoCard.styles';
import { getQuoteTypes } from '../../../features/utilities/utilitiesActions';
import TutelaLegaleModalButtons from '../../../common/components/redesignComponents/ResultPageComponents/TutelaLegaleModalButtons';
import ModalQuotesTutela from '../../../common/components/redesignComponents/ResultPageComponents/ModalQuotesTutela';
import { V2FontImport } from '../../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import TutelaLegaleSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/TutelaLegaleSummaryCard';
import QuoteCostSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import FailedQuotationsComponent from '../../../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

function BackOfficeTutelaLegaleQuotes() {
  const { requestToken } = useParams();
  const state = useSelector((store) => store.backofficeResults.back_office_quotes);
  const {
    loading,
    requestInfo,
    quotes,
    failedQuotes,
    processingQuote,
    addingQuote,
    customer,
    risk_quotations,
  } = state;
  // const modifyData = () => {
  //   navigate(`/backoffice/quote/${requestToken}/tutela-legale`);
  // };

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  useEffect(() => {
    loadBackOfficeQuotes(requestToken);
    getQuoteTypes();

    return () => {
      resetBackOfficeQuotes();
    };
  }, []);

  const refresh = () => loadBackOfficeQuotes(requestToken);

  if (loading) {
    return <PageLoading />;
  }

  const fetchQuotes = () => {
    loadBackOfficeQuotes(requestToken);
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addBackOfficeQuoteToCart(quoteId, fetchQuotes));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeBackOfficeQuoteFromCart(quoteId, fetchQuotes));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (risk_quotations && risk_quotations[type.id] !== undefined) {
        for (let i = 0; i < risk_quotations[type.id].length; i++) {
          const item = risk_quotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (
      quoteInProccessAmount
      + risksTotalAmount
    ).toFixed(2);
  };

  return (
    <Layout>
      <V2FontImport />
      <RcQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <TutelaLegaleSummaryCard customer={customer} insuranceRequest={requestInfo} />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={risk_quotations}
              getTotal={getTotal}
            />
          </ResultOverviewRow>

          {quotes && !quotes.res_civile
            && (
              <div className="alert alert-info mx-2" role="alert">
                <h4 className="alert-heading">Avviso!</h4>
                <p className="m-0">Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </div>
            )}

          {quotes && quotes.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => (
                    <React.Fragment key={index}>
                      {quotes && quotes[type.id] && (
                        <TutelaLegaleModalButtons
                          userData={requestInfo}
                          processingQuote={processingQuote}
                          type={type}
                          removeItemFromCart={removeItemFromCart}
                          riskQuotations={risk_quotations}
                          quotations={quotes}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </RiskContainer>
                {quoteTypes.map((type, index) => (
                  <ModalQuotesTutela
                    key={index}
                    userData={requestInfo}
                    type={type}
                    index={index}
                    addingQuote={addingQuote}
                    quotations={quotes}
                    selectQuotation={selectQuotation}
                    processingQuote={processingQuote}
                    refresh={refresh}
                  />
                ))}
              </>
            )}

          {failedQuotes !== null && failedQuotes?.length > 0 && (
            <FailedQuotationsComponent failedQuotes={failedQuotes} />
          )}
        </div>
      </RcQuotesStyles>
    </Layout>
  );
}

export default BackOfficeTutelaLegaleQuotes;
